import {HRToolCard} from "components/hr/widgets/HRToolCard";

declare var document:any;
import {UIState} from "data/UIState";
import * as React from "react";
import HRRegisterChart from "components/hr/main/dashboard/HRRegisterChart";
import {observer} from "mobx-react";
import {Helpers} from "data/hr/Helpers";
import './HRDashboard.pcss';
import {Transport} from "data/transport";

export const HRDashboard = observer(() => {

  const accountCreationReport = (e) => {
    e.preventDefault();
    document.location =  Transport.URL("/hr/registrationReport", true);
  }

  const pointsReport = (solutionId) => {
    document.location =  Transport.URL("/hr/solutionParticipationReport?solutionId="+solutionId, true);
  }

  return (
    <div>

      <div>

        {UIState.dashboardData.initialized &&
          <>
            {(UIState.dashboardData.data && UIState.dashboardData.data.participants.length > 0)
              ?
              <>
                <HRToolCard title={"Account Signups"}>
                  <div style={{height: '300px'}}>
                    <HRRegisterChart registrationData={UIState.dashboardData.data.participants}/>
                  </div>
                </HRToolCard>


                <HRToolCard title={"Platform Report"}>
                  <table className={"hr-reports"}>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Signup Export</td>
                        <td><a onClick={accountCreationReport}><span className="material-symbols-outlined">download</span></a></td>
                      </tr>
                    </tbody>
                  </table>
                </HRToolCard>


                <HRToolCard title={"Participation Reports"}>
                  <table className={"hr-reports"}>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Visible Date</th>
                        <th>Open Date</th>
                        <th>Close Date</th>
                        <th>Badge</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                    {UIState.dashboardData.data.solutions.map((solution)=> {
                      const visibleDate = Helpers.standardDate(solution.visibleDate);
                      const openDate = solution.alwaysAvailable ? "Always open" : Helpers.standardDate(solution.openDate);
                      const closeDate = solution.alwaysAvailable ? "" : Helpers.standardDate(solution.closeDate);
                      return (
                        <tr key={solution._id}>
                          <td>{solution.name}</td>
                          <td>{visibleDate}</td>
                          <td>{openDate}</td>
                          <td>{closeDate}</td>
                          <td>{solution.badgeUsed ?"YES":""}</td>
                          <td><a onClick={(e) => {
                            e.preventDefault();
                            pointsReport(solution._id);
                          }}><span className="material-symbols-outlined">download</span></a></td>

                        </tr>
                      )

                    })}
                    </tbody>
                  </table>
                </HRToolCard>

              </>
              :
              <p style={{padding: '0 8px'}}>No registrations yet. Please check back.</p>
            }
        </>
        }
      </div>



    </div>
  );
});
